import * as React from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { deleteTitle, messages } from '../messages';
import { classNames, IconWrap } from '@progress/kendo-react-common';
import { arrowRotateCwIcon, arrowsNoRepeatIcon, xIcon } from '@progress/kendo-svg-icons';
import { useEditable } from '../hooks';
/**
 * Represents the default `task` component rendered by the [KendoReact Scheduler component]({% slug overview_scheduler %}).
 *
 * The SchedulerTask is the default representation of an event inside the [`AgendaView`]({% slug agenda_view_scheduler %}).
 */
export var SchedulerTask = React.forwardRef(function (props, ref) {
    var _ref = props._ref, onRemoveClick = props.onRemoveClick;
    var task = React.useRef(null);
    var element = React.useRef(null);
    React.useImperativeHandle(task, function () { return ({ props: props, element: element.current }); });
    React.useImperativeHandle(ref, function () { return task.current; });
    React.useImperativeHandle(_ref, function () { return task.current; });
    var editable = useEditable(props.editable);
    var localization = useLocalization();
    var deleteMessage = localization.toLanguageString(deleteTitle, messages[deleteTitle]);
    var resource = props.group.resources.find(function (r) { return Boolean(r.colorField && r[r.colorField] !== undefined); });
    var color = resource && resource.colorField && resource[resource.colorField];
    var handleRemoveClick = React.useCallback(function (syntheticEvent) {
        if (!onRemoveClick) {
            return;
        }
        onRemoveClick.call(undefined, {
            syntheticEvent: syntheticEvent,
            target: task.current
        });
    }, [onRemoveClick, task]);
    var className = React.useMemo(function () { return classNames('k-task', props.className); }, [props.className]);
    return (React.createElement("div", { id: props.id, ref: element, style: props.style, className: className, tabIndex: props.tabIndex || undefined },
        color && (React.createElement("span", { className: "k-scheduler-mark", style: { color: color, backgroundColor: color } })),
        props.isRecurring && React.createElement(IconWrap, { name: "arrow-rotate-cw", icon: arrowRotateCwIcon }),
        props.isException && React.createElement(IconWrap, { name: "arrows-no-repeat", icon: arrowsNoRepeatIcon }),
        props.title,
        editable.remove && (React.createElement("a", { className: "k-link k-event-delete", title: deleteMessage, "aria-label": deleteMessage, onClick: handleRemoveClick },
            React.createElement(IconWrap, { name: "x", icon: xIcon })))));
});
SchedulerTask.displayName = 'KendoReactSchedulerTask';
